import type { IssuedDoc, IssuedStatus, ReceivedDoc } from "./types";

export const ISSUED_LABEL: Record<IssuedStatus, string> = {
  en_cours: "En cours",
  deposee: "Déposée",
  acceptee: "Acceptée",
  refusee: "Refusée",
  rejet: "Rejet technique",
};

export const ISSUED: IssuedDoc[] = [
  {
    id: "i1",
    number: "2026-09-09-0660",
    client: "Studio Seth",
    amount: "1 240,00 €",
    sentAt: "9 sept. 2026",
    status: "acceptee",
    motif: "Le client a accepté. La pièce ne se modifie plus.",
    steps: [
      { label: "Validée dans FacturX", at: "9 sept. 09:12", done: true },
      { label: "Déposée", at: "9 sept. 09:13", done: true },
      { label: "Chez le client", at: "9 sept. 09:14", done: true },
      { label: "Acceptée", at: "12 sept. 11:02", done: true },
    ],
  },
  {
    id: "i2",
    number: "2026-09-12-0661",
    client: "Accords Majeurs",
    amount: "890,00 €",
    sentAt: "12 sept. 2026",
    status: "en_cours",
    motif: "Mise à disposition. On attend sa réponse.",
    steps: [
      { label: "Validée dans FacturX", at: "12 sept. 16:40", done: true },
      { label: "Déposée", at: "12 sept. 16:41", done: true },
      { label: "Chez le client", at: "12 sept. 16:42", done: true },
      { label: "Acceptée ou refusée", at: "en attente", done: false },
    ],
  },
  {
    id: "i3",
    number: "2026-09-14-0662",
    client: "Atelier Lumière",
    amount: "2 180,00 €",
    sentAt: "14 sept. 2026",
    status: "refusee",
    motif: "Montant contesté par le client.",
    steps: [
      { label: "Validée dans FacturX", at: "14 sept. 10:05", done: true },
      { label: "Déposée", at: "14 sept. 10:06", done: true },
      { label: "Chez le client", at: "14 sept. 10:07", done: true },
      { label: "Refusée", at: "15 sept. 08:21", done: true },
    ],
  },
  {
    id: "i4",
    number: "2026-09-15-0663",
    client: "Studio Seth",
    amount: "360,00 €",
    sentAt: "15 sept. 2026",
    status: "rejet",
    motif: "SIREN destinataire introuvable dans l’annuaire.",
    steps: [
      { label: "Validée dans FacturX", at: "15 sept. 14:02", done: true },
      { label: "Dépôt refusé", at: "15 sept. 14:03", done: true },
      { label: "Chez le client", at: "—", done: false },
      { label: "Acceptée ou refusée", at: "—", done: false },
    ],
  },
  {
    id: "i5",
    number: "2026-09-16-0664",
    client: "Maison Nord",
    amount: "540,00 €",
    sentAt: "16 sept. 2026",
    status: "deposee",
    motif: "Reçue par le facteur, acheminement en cours.",
    steps: [
      { label: "Validée dans FacturX", at: "16 sept. 08:50", done: true },
      { label: "Déposée", at: "16 sept. 08:51", done: true },
      { label: "Chez le client", at: "en cours", done: false },
      { label: "Acceptée ou refusée", at: "—", done: false },
    ],
  },
];

export const RECEIVED: ReceivedDoc[] = [
  {
    id: "r1",
    number: "F-2026-4412",
    supplier: "EDF",
    amount: "142,80 €",
    receivedAt: "10 sept. 2026",
    status: "cabinet",
    motif: "Copie envoyée au cabinet. Rien à saisir ici.",
  },
  {
    id: "r2",
    number: "OVH-88421",
    supplier: "OVHcloud",
    amount: "48,00 €",
    receivedAt: "12 sept. 2026",
    status: "a_voir",
    motif: "À ouvrir. Le cabinet la récupère aussi de son côté.",
  },
  {
    id: "r3",
    number: "2026-08-190",
    supplier: "Fournitures Martin",
    amount: "890,40 €",
    receivedAt: "8 sept. 2026",
    status: "recue",
    motif: "Arrivée sur le SIREN. Lecture + PDF, pas une écriture comptable.",
  },
];

export function issuedCount(status: IssuedStatus): number {
  return ISSUED.filter((row) => row.status === status).length;
}
